import { render, staticRenderFns } from "./VoteListRank.vue?vue&type=template&id=2df4d10b&scoped=true&"
import script from "./VoteListRank.vue?vue&type=script&lang=js&"
export * from "./VoteListRank.vue?vue&type=script&lang=js&"
import style0 from "./VoteListRank.vue?vue&type=style&index=0&id=2df4d10b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4d10b",
  null
  
)

export default component.exports